import { render } from "./RosterPage.vue?vue&type=template&id=5b2f70e1&scoped=true"
import script from "./RosterPage.vue?vue&type=script&lang=js"
export * from "./RosterPage.vue?vue&type=script&lang=js"

import "./RosterPage.vue?vue&type=style&index=0&id=5b2f70e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2f70e1"]])

export default __exports__